<wlm-dynamic-layout [settings]="dynamicLayoutSettings"></wlm-dynamic-layout>
